/* EventRequester.js */

'use strict';

class ViewChangeRequester {
    static get singleton() {
        return window.gViewChangeRequester;
    }

    constructor(ngRootScope) {
        if (window.gViewChangeRequester) {
            return window.gViewChangeRequester;
        }
        this.ngRootScope = ngRootScope;
        Object.defineProperty(window, 'gViewChangeRequester', {
            value: this,
            writable: false
        });
    }

    /**
     * This is a function that will wait for verification to change the view in the application.  The value will
     * return a boolean.  If true is returned then it is ok to proceed and change the view.
     * If false is returned then one of the listeners for the event replied that it was not
     * ok to switch the view.
     *
     * The function will send out an angular event "gl_global.view.change.request" along with an object
     * that contains a function to addConfirm.  If the listener adds a confirm promise to the request, then
     * the request will wait for the confirm to complete. The confirm promise will return either a true or false.
     *
     * @returns {Promise<*>}
     */
    async requestViewChange(requestData) {
        if (this.currentRequestPromise) {
            return this.currentRequestPromise;
        } else {
            this.currentRequestPromise = new Promise((resolve/*, reject*/) => {
                let confirmPromises = [];
                let addConfirmWait = function (confirmPromise) {
                    confirmPromises.push(confirmPromise);
                };
                let request = {
                    addConfirmWait: addConfirmWait
                };
                if (requestData) {
                    request.requestData = requestData;
                }
                this.ngRootScope.$broadcast('gl_global.view.change.request', request);
                return Promise.all(confirmPromises)
                  .then((results) => {
                      let proceed = true;
                      results.forEach((result) => {
                          if (!result) {
                              proceed = false;
                          }
                      });
                      this.currentRequestPromise = null;
                      resolve(proceed);
                  });

            });
            return this.currentRequestPromise;
        }
    }
}

module.exports = ViewChangeRequester;